export default "__VITE_ASSET__Cqv9EJeM__"